export default "__VITE_ASSET__3626427f__"